import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import BackgroundImage from "./background_image"
import { motion } from "framer-motion";

import "./demo_section.scss"

const DemoSection = ({centered, ...props}) => {

  let imageOrder, contentOrder;
  props.right === true ? imageOrder = 'order-2' : imageOrder = 'order-1'
  props.right !== true ? contentOrder = 'order-2' : contentOrder = 'order-1'

  return (
    <section>
    <div style={{position: "relative"}} className="demo-section">
      {props.bgOff === true ? null : <BackgroundImage/>}
    <div className="container py-md-5 d-flex align-items-center my-md-5">
      <div className={props.right === true ? "row demo-text-and-image-reverse justify-content-center flex-md-row" : "row demo-text-and-image justify-content-center flex-md-row"}>
        <div className={centered === true ? contentOrder + " col-md-12 col-lg-6 info-content d-flex flex-column justify-content-center text-center align-items-center" : contentOrder + " col-md-12 col-lg-6 info-content d-flex flex-column justify-content-center"}>
          {props.boldBefore ? <h2><strong>{props.headlineBold}</strong><br/>{props.headline}</h2>:null}
          {props.boldAfter ? <h2>{props.headline}<br/><strong>{props.headlineBold}</strong></h2>:null}
          <p className="caption py-2">
            {props.paragraph}
          </p>
          <a href={props.buttonHref}>
            <motion.button
              whileHover={{
                y: -4,
                boxShadow: "0px 8px 16px rgba(0, 250, 183, 0.4)", // pink shadow
                backgroundImage: "linear-gradient(90deg, #00CB94 0%, #108FFF 100%)",
              }}
              transition={{
                type: "tween",
                ease: "easeOut",
                duration: 0.2,
              }}
              className="bg-primary blue-cta-button p-2 px-4 mt-2 w-100 d-flex align-items-center justify-content-center"
            >
              {props.scheduleDemo === true ? 'Schedule a Free Demo' : 'Request a Demo'}
              <StaticImage
                style={{ marginLeft: '.5rem' }}
                quality={100}
                src="../images/right-arrow.svg"
                alt="demo-section-img"
              />
            </motion.button>
          </a>
        </div>
        <div className={imageOrder + " col-8 col-lg-4 ps-xl-5 text-center"} >
          <StaticImage
            quality={100}
            src="../images/demo-section-image.png"
            alt="demo-section-img"
          />
        </div>
      </div>
    </div>
    </div>
    </section>
  )
}

export default DemoSection
